module.exports = __webpack_public_path__ + "img/Documents.ae863230.svg";